module.exports = __webpack_public_path__ + "assets/img/google.9afedb45.svg";